<button [disabled]="disabled" [ngClass]="getClass()">
  <ng-content></ng-content>
</button>
